<button
  nz-button
  nz-dropdown
  [class.no-action]="disabled"
  [disabled]="disabled"
  [ngClass]="classList"
  [nzDropdownMenu]="menu"
  [nzLoading]="inProgress"
  [nzTrigger]="triggerMode"
  [nzType]="nzType"
  (nzVisibleChange)="onOpenMenuTrigger($event)">
  <ui-icon
    class="sh-button-icon"
    *ngIf="icon && iconPlacement === 'left'"
    [key]="iconKey"
    [ngClass]="{ 'sh-lighter-icon': hasLighterIcon }"></ui-icon>

  <ng-container *ngIf="label">{{ label }}</ng-container>

  <ui-icon
    class="sh-button-icon"
    *ngIf="icon && iconPlacement === 'right' && !chevron"
    [key]="iconKey"
    [ngClass]="{ 'sh-lighter-icon': hasLighterIcon }"></ui-icon>

  <ui-icon
    class="sh-button-icon"
    *ngIf="chevron"
    [key]="'chevron-down'"
    [ngClass]="{ 'sh-lighter-icon': hasLighterIcon }"></ui-icon>
</button>

<nz-dropdown-menu #menu="nzDropdownMenu">
  <ul nz-menu>
    <ng-container *ngFor="let menuItem of menuItems; let i = index">
      <ng-container *ngTemplateOutlet="liMenuItem; context: { $implicit: menuItem, index: i }"></ng-container>
      <li
        nz-submenu
        *ngIf="!menuItem.divider && menuItem.labelCode && menuItem.submenu"
        [ngClass]="{ 'menu-item-selectable': menuItem.selectable && !menuItem.selected, 'menu-item-selected': menuItem.selected }"
        [nzTitle]="submenuTitle">
        <ng-template #submenuTitle>
          <span>{{ menuItem.labelCode | transloco }}</span>
          <ui-icon
            class="sh-button-icon sh-lighter-icon"
            [key]="'chevron-right'"></ui-icon>
        </ng-template>
        <ul>
          <ng-container *ngFor="let menuItem of menuItem.submenu; let i = index">
            <ng-container *ngTemplateOutlet="liMenuItem; context: { $implicit: menuItem, index: i }"></ng-container>
            <li
              nz-menu-divider
              *ngIf="menuItem.divider"></li>
          </ng-container>
        </ul>
      </li>
      <li
        nz-menu-divider
        *ngIf="menuItem.divider"></li>
    </ng-container>
  </ul>
  <ng-template
    let-index
    let-menuItem
    #liMenuItem>
    <li
      nz-menu-item
      *ngIf="!menuItem.divider && menuItem.labelCode && !menuItem.submenu"
      [id]="index"
      [ngClass]="{ 'menu-item-selectable': menuItem.selectable || menuItem.selected, 'menu-item-selected': menuItem.selected }"
      [nzDisabled]="menuItem.disabled"
      (click)="menuItemSelected(menuItem)">
      <ui-icon
        *ngIf="menuItem.selected"
        [key]="'check'"></ui-icon>
      {{ menuItem.labelCode | transloco }}
      <span
        class="menu-item-suffix"
        *ngIf="menuItem.suffixCode"
        >{{ menuItem.suffixCode | transloco }}</span
      >
    </li>
  </ng-template>
</nz-dropdown-menu>
